module.exports = __webpack_public_path__ + "dingbeauty-build/img/lightbox_close.b90b9d74.svg";